import { render } from "./Game_Create.vue?vue&type=template&id=33595377&scoped=true"
import script from "./Game_Create.vue?vue&type=script&lang=js"
export * from "./Game_Create.vue?vue&type=script&lang=js"

import "./Game_Create.vue?vue&type=style&index=0&id=33595377&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33595377"]])

export default __exports__